import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const handle = async (fn) => {
  try {
    const res = await fn();
    return { status: res.status, data: res.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      data: null,
      message: err.response?.data?.message || err.message || "Request failed",
    };
  }
};

export const createZoomMeeting = (payload) =>
  handle(() => api.post("/admin/zoom-meetings", payload));

export const fetchZoomMeetings = () =>
  handle(() => api.get("/admin/zoom-meetings"));

export const fetchZoomMeetingById = (id) =>
  handle(() => api.get(`/admin/zoom-meetings/${id}`));

export const deleteZoomMeeting = (id) =>
  handle(() => api.delete(`/admin/zoom-meetings/${id}`));

export const sendZoomReminder = (id) =>
  handle(() => api.post(`/admin/zoom-meetings/${id}/send-reminder`, null, {
    params: { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone },
  }));

export const cancelZoomMeeting = (id) =>
  handle(() => api.put(`/admin/zoom-meetings/${id}/cancel`));

export const searchUserEmails = (q) =>
  handle(() => api.get(`/admin/users/search-emails`, { params: { q } }));
